import styled from 'styled-components';

import Avatar from '../shared/Avatar';
import { OverflowButton } from './OverflowButton';

import fontFamily from '../data/font-family';

export const Header = styled.div`
  align-items: center;
  display: flex;
  font-family: ${fontFamily};
  margin: 16px 8px;

  ${Avatar} {
    align-self: flex-start;
    flex: 0 0 auto;
  }

  ${OverflowButton} {
    margin-left: auto;
    align-self: flex-start;
    flex: 0 0 auto;
  }
`;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-detail/Header.js